// We're storing this data as JSON blob, this can helpful in the future
// in case of breaking changes
export var SMART_CONTAINER_VERSION = 1;
export function getSmartContainerData(note) {
    if (!note)
        return undefined;
    try {
        var data = JSON.parse(note);
        // Convert legacy scroll containers data.
        if (data.scrollContainer) {
            var _a = data.scrollContainer, hasScrollbars = _a.scrollbars, scrollDirection = _a.direction, scrollBehaviour = _a.behaviour;
            return {
                scrollable: {
                    isEnabled: true,
                    hasScrollbars: hasScrollbars,
                    scrollDirection: scrollDirection,
                    scrollBehaviour: scrollBehaviour,
                },
                fixedPosition: {
                    isEnabled: false,
                },
                version: SMART_CONTAINER_VERSION,
            };
        }
        if (data.smartContainer) {
            return data.smartContainer;
        }
        // eslint-disable-next-line no-empty
    }
    catch (_b) { }
    return undefined;
}
// TODO: we should create a different package to share TS interfaces
// across different projects
export var ScrollBehaviour;
(function (ScrollBehaviour) {
    ScrollBehaviour["Normal"] = "normal";
    ScrollBehaviour["Paging"] = "page";
})(ScrollBehaviour || (ScrollBehaviour = {}));
export var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection["Both"] = "both";
    ScrollDirection["Horizontal"] = "horizontal";
    ScrollDirection["Vertical"] = "vertical";
})(ScrollDirection || (ScrollDirection = {}));
export function getFormFieldData(note) {
    if (!note)
        return undefined;
    var initialValue = {
        formField: {
            text: {
                prefilled: '',
                color: '#000000',
                type: 'Textarea',
                font: {
                    typeface: 'Helvetica',
                    weight: 'Semibold',
                    size: 12,
                },
            },
            placeholder: {
                text: '',
                color: '#C0C0C0',
            },
            padding: {
                left: 12,
                top: 12,
                right: 12,
                bottom: 12,
            },
        },
    };
    return initialValue;
}
